import { useContext, useState, useEffect, useRef } from "react";
import GlobalState from '../contexts/GlobalState';
import { useNavigate, useParams } from "react-router";
import React from 'react';
import Layout from "../components/Layout";
import Api from "../components/Api";
import Documents from "../components/Documents";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import ReminderPopup from "../components/ReminderPopup";


import { registerLocale } from "react-datepicker";
import ar from 'date-fns/locale/ar';
import LitigationGeneralInfo from "../components/LitigationGeneralInfo";
import LitigationStageActivitiesComponent from "../components/LitigationStageActivitiesComponent";
import { AttachIconInput, CloseIcon } from "../components/Icons";
import LitigationsReminder from "../components/LitigationsReminders";
import LitigationCosts from "../components/LitigationCosts";
import LitigationRelations from "../components/LitigationRelations";
import { formatDate, getIndex } from '../Helpers';
registerLocale('ar', ar)

export default function MattersDetails() {

    const {
        generalDataGlobal,
        openAddReminderGlobal,
        authUserGlobal,
        profileClientGlobal,
        activeMatter, setActiveMatter,
        setAllLitigations,
    } = useContext(GlobalState);
    const [generalDataApiOptions, setGeneralDataApiOptions] = useState({});
    let { slug, user_id, folder_id, matter_id, type } = useParams();
    const [generalData] = generalDataGlobal;
    const [authUser,] = authUserGlobal;
    const [usersApiOptions,] = useState({});
    const [profileClient, setProfileClient] = profileClientGlobal;
    const history = useNavigate();
    const [swiper, setSwiper] = useState(null);
    const [securityCheck, setSecurityCheck] = useState(0);
    const [, setAddMore] = useState(false);
    const refAdd = useRef(null);
    const [openAddReminder,] = openAddReminderGlobal;
    const [deleteMatter, setDeleteMatter] = useState('');

    // const handleAddMatterClick = (e, type) => {
    //     e.preventDefault();
    //     setAddMatterPopup({
    //         open: true,
    //         type: type
    //     });
    // }

    //get all currencies
    const allCurrencies = () => {
        const curren = generalData?.currencies?.map(
            singleOption => ({ value: singleOption.id, label: singleOption.title, slug: singleOption.slug }))
        return curren;
    }

    //function to add years to a date
    function addYears(date, years) {
        date.setFullYear(date.getFullYear() + years);
        return date;
    }

    //handle document upload
    const documentHandler = (files) => {
        if (files.length > 0) {
            setDocument(files);
            let file = URL.createObjectURL(files[0])
            // setTempFile(file);
            setDocumentLink(file);
        }
    }

    //get all transaction types
    const allTransactionTypes = () => {
        const transactionType = generalData?.transaction_types?.map(
            singleOption => ({ value: singleOption.id, label: singleOption.title }))
        return transactionType;
    }

    //get all users
    const allUsers = () => {
        const curren = generalData?.users?.map(
            singleOption => ({ value: singleOption.id, label: <div><img className="select-image me-1" src={singleOption?.picture ? singleOption?.full_path_picture : generalData?.fixed_settings?.full_path_no_profile_picture} alt={singleOption?.name} />{singleOption?.name}</div> }))
        return curren;
    }
    /* transactions start */
    const [addTransaction, setAddTransaction] = useState(false);
    const [, setOpenEditTransaction] = useState(null);
    const [transactionType, setTransactionType] = useState(allTransactionTypes()[getIndex(5, allTransactionTypes(), 'value')]);
    const [transactionCurrency, setTransactionCurrency] = useState('');
    const [transactionTo, setTransactionTo] = useState(allUsers()[getIndex(Number(authUser?.id), allUsers(), 'value')]);
    const [currenEditTransaction, setCurrenEditTransaction] = useState('');
    const [transactionAmount, setTransactionAmount] = useState('');
    const [addTransactionDate, setAddTransactionDate] = useState(new Date());
    const [addTransactionNote, setAddTransactionNote] = useState('');

    /* transactions start */

    // close transaction popup and reset states
    function closeAddTransaction(e) {
        e.preventDefault();
        setAddTransaction(false);
        setTransactionAmount('');
        setTransactionCurrency('');
        setAddTransactionDate(new Date());
        setCurrenEditTransaction(null);
        setAddTransactionNote('');
        if (authUser?.id !== user_id) {
            setTransactionTo(allUsers()[getIndex(Number(authUser?.id), allUsers(), 'value')]);
        }
        setErrorsReturned({});
    }

    //custom select styles
    const customStylesPopupCurr = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                display: "flex",
                fontFamily: 'Poppins',
                fontWeight: '400',
                textTransform: "capitalize",
                fontSize: '14px',
                color: '#07407C',
            }
        },
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                color: '#07407C',
                fontFamily: 'Poppins',
                fontWeight: '400',
                backgroundColor: 'white',
                textTransform: "capitalize",
                margin: "auto",
                paddingRight: "10px",
                maxWidth: "100%",
                paddingLeft: "10px",
                paddingBottom: "0",
                paddingTop: "0",
            };
        },
        singleValue: base => ({
            ...base,
            color: "#00366A",
            display: "flex",
            fontSize: "14px",
            fontFamily: "Poppins",
            fontWeight: "400",
            textTransform: "capitalize",
        }),
        control: provided => ({
            ...provided,
            height: "40px",
            border: "none",
            backgroundColor: 'white',
            outline: "none",
            '&:hover': { borderColor: 'transparent' },
            textTransform: 'uppercase',
            width: "100%",
            borderRadius: "7px",
            fontFamily: 'Poppins',
            fontWeight: '400',
            boxShadow: "0px 3px 6px rgb(0 0 0 / 16%)",
        }),
        menu: (provided, state) => ({
            ...provided,
            borderRadius: "7px",
            textTransform: 'uppercase',
            border: "1px solid transparent",
        }),
        dropdownIndicator: base => ({
            ...base,
            color: "#00366A !important",
            marginTop: "-18px !important"
        }),
        input: (base, state) => ({
            ...base,
            color: "#393939",
            fontSize: "16px",
            height: "100%",
            fontFamily: 'Poppins',
            textTransform: 'uppercase',
            fontWeight: '400',
            marginTop: "14px",
            '& input': {
                font: 'inherit',
            },
        })
    };

    //custom select styles
    const customStylesUsersPopup = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                display: "flex",
                fontFamily: 'Poppins',
                fontWeight: '400',
                textTransform: "capitalize",
                fontSize: '14px',
                color: '#07407C',
            }
        },
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                color: '#07407C',
                fontFamily: 'Poppins',
                fontWeight: '400',
                backgroundColor: 'white',
                textTransform: "capitalize",
                margin: "auto",
                paddingRight: "10px",
                maxWidth: "100%",
                paddingLeft: "10px",
                paddingBottom: "2px",
                paddingTop: "2px",
            };
        },
        singleValue: base => ({
            ...base,
            color: "#00366A",
            display: "flex",
            fontSize: "14px",
            fontFamily: "Poppins",
            fontWeight: "400",
            textTransform: "capitalize",
        }),
        control: provided => ({
            ...provided,
            height: "40px",
            border: "none",
            backgroundColor: 'white',
            outline: "none",
            '&:hover': { borderColor: 'transparent' },
            textTransform: 'uppercase',
            width: "100%",
            borderRadius: "7px",
            fontFamily: 'Poppins',
            fontWeight: '400',
            boxShadow: "0px 3px 6px rgb(0 0 0 / 16%)",
        }),
        menu: (provided, state) => ({
            ...provided,
            borderRadius: "7px",
            textTransform: 'uppercase',
            border: "1px solid transparent",
        }),
        dropdownIndicator: base => ({
            ...base,
            color: "#00366A !important",
            // marginTop: "-18px !important"
        }),
        input: (base, state) => ({
            ...base,
            color: "#393939",
            fontSize: "16px",
            height: "100%",
            fontFamily: 'Poppins',
            textTransform: 'uppercase',
            fontWeight: '400',
            marginTop: "14px",
            '& input': {
                font: 'inherit',
            },
        })
    };

    // custom styles for the select
    const customStylesPopup = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                display: "flex",
                fontFamily: 'Poppins',
                fontWeight: '400',
                textTransform: "capitalize",
                fontSize: '14px',
                color: '#07407C',
            }
        },
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                color: '#07407C',
                fontFamily: 'Poppins',
                fontWeight: '400',
                backgroundColor: 'white',
                textTransform: "capitalize",
                margin: "auto",
                paddingRight: "10px",
                maxWidth: "100%",
                paddingLeft: "10px",
                paddingBottom: "0",
                paddingTop: "0",
            };
        },
        singleValue: base => ({
            ...base,
            color: "#00366A",
            display: "flex",
            fontSize: "14px",
            fontFamily: "Poppins",
            fontWeight: "400",
            textTransform: "capitalize",
        }),
        control: provided => ({
            ...provided,
            height: "40px",
            border: "none",
            backgroundColor: 'white',
            outline: "none",
            '&:hover': { borderColor: 'transparent' },
            textTransform: 'uppercase',
            width: "100%",
            borderRadius: "7px",
            fontFamily: 'Poppins',
            fontWeight: '400',
            boxShadow: "0px 3px 6px rgb(0 0 0 / 16%)",
        }),
        menu: (provided, state) => ({
            ...provided,
            borderRadius: "7px",
            textTransform: 'uppercase',
            border: "1px solid transparent",
        }),
        dropdownIndicator: base => ({
            ...base,
            color: "#00366A !important",
            // marginTop: "-18px !important"
        }),
        input: (base, state) => ({
            ...base,
            color: "#393939",
            fontSize: "16px",
            height: "100%",
            fontFamily: 'Poppins',
            textTransform: 'uppercase',
            fontWeight: '400',
            marginTop: "14px",
            '& input': {
                font: 'inherit',
            },
        })
    };

    /* handle click outside to close custom dropdown start*/
    const useOutsideClick = (ref, callback) => {
        const handleClick = e => {
            if (ref.current && !ref.current.contains(e.target)) {
                callback();
            }
        };

        useEffect(() => {
            window?.document.addEventListener("click", handleClick);

            return () => {
                window?.document.removeEventListener("click", handleClick);
            };
        });
    };

    useOutsideClick(refAdd, () => {
        setAddMore(false);
    });
    /* handle click outside to close custom dropdown end*/

    /* Files Start */

    /* expenses start */
    const [addExpenses, setAddExpenses] = useState(false);
    const [currenEditExpense, setCurrenEditExpense] = useState('');
    const [addExpensesType, setAddExpensesType] = useState('');
    const [addExpensesAmount, setAddExpensesAmount] = useState('');
    const [addExpensesCurrency, setAddExpensesCurrency] = useState('');
    const [addExpensesDate, setAddExpensesDate] = useState(new Date());
    const [addExpensesNote, setAddExpensesNote] = useState('');
    const [addExpensesBillable, setAddExpensesBillable] = useState(0);
    /* expenses end */

    //submit transactions
    const submitTransactions = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let fd = new FormData();
        fd.append('transaction_type_id', transactionType ? transactionType?.value : '');
        fd.append('currency_id', transactionCurrency ? transactionCurrency?.value : '');
        fd.append('receiver_id', transactionTo ? transactionTo?.value : '');
        fd.append('currency', 'usd');
        fd.append('user_id', user_id);
        fd.append('amount', transactionAmount ? transactionAmount : '');
        fd.append('date', addTransactionDate ? formatDate(addTransactionDate) : '');
        fd.append('note', addTransactionNote ? addTransactionNote : '');
        fd.append('client_id', user_id);


        setGeneralDataApiOptions({
            url: 'add-client-transaction',
            method: 'post',
            data: fd,
            callback: res => {
                setErrorsReturned({});
                closeAddTransaction(e);
                setOpenEditTransaction(null);
            },
            catch: err => {
                if (err) {
                    setErrorsReturned(err);
                }
            }
        })
    };

    //custom select styles
    const customStylesFiles = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                display: "flex",
                fontFamily: 'Poppins',
                fontWeight: '400',
                textTransform: "capitalize",
                fontSize: '14px',
                color: '#00366A',
            }
        },
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                display: "flex",
                color: '#00366A',
                fontFamily: 'Poppins',
                fontWeight: '400',
                backgroundColor: 'white',
                textTransform: "capitalize",
                margin: "auto",
                paddingRight: "10px",
                paddingLeft: "10px",
                paddingBottom: "0",
                paddingTop: "0",
            };
        },
        singleValue: base => ({
            ...base,
            color: "#00366A",
            display: "flex",
            fontSize: "14px",
            fontFamily: "Poppins",
            fontWeight: "400",
            textTransform: "capitalize",
        }),
        control: provided => ({
            ...provided,
            border: "none",
            backgroundColor: 'white',
            outline: "none",
            '&:hover': { borderColor: 'transparent' },
            textTransform: 'uppercase',
            width: "100%",
            borderRadius: "7px",
            fontFamily: 'Poppins',
            fontWeight: '400',
            minHeight: "40px",
            height: "40px",
            boxShadow: "0px 3px 6px rgb(0 0 0 / 16%)",
        }),
        menu: (provided, state) => ({
            ...provided,
            borderRadius: "7px",
            textTransform: 'uppercase',
            border: "1px solid transparent",
        }),
        dropdownIndicator: base => ({
            ...base,
            color: "#00366A !important",
            // marginTop: "-18px !important"
        }),
        input: (base, state) => ({
            ...base,
            color: "#393939",
            fontSize: "16px",
            height: "40px",
            fontFamily: 'Poppins',
            textTransform: 'uppercase',
            fontWeight: '400',
            marginTop: "14px",
            '& input': {
                font: 'inherit',
            },
        })
    };

    const [errorsReturned, setErrorsReturned] = useState({});
    const [uploadFilePopup, setUploadFilePopup] = useState(false);
    const [fileName, setFileName] = useState('');
    const [fileType, setFileType] = useState('');
    const [fileComment, setFileComment] = useState('');
    const [document, setDocument] = useState();
    const [documentLink, setDocumentLink] = useState();
    // const [tempFile, setTempFile] = useState();
    const [, setFileMenuOpen] = useState();
    const [editingFile, setEditingFile] = useState();

    //handle file upload documents
    const documentHandlerFiles = (files) => {
        if (files.length > 0) {
            setDocument(files);
            let file = URL.createObjectURL(files[0])
            // setTempFile(file);
            setDocumentLink(file);
        }
    }

    //submit files
    const submitFiles = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let fd = new FormData();

        fd.append('main_directory', 2);
        fd.append('user_id', user_id);
        fd.append('folder_id', '');
        if (editingFile?.id) {
            fd.append('file_id', editingFile?.id);
        }
        fd.append('file_name', fileName);
        fd.append('files_type_id', fileType ? fileType?.value : '');
        fd.append('comment', fileComment);

        if (document) {
            fd.append('file', document[0]);
        }
        fd.append('client_id', user_id);
        fd.append('individual', 1);


        setGeneralDataApiOptions({
            url: 'submit-files',
            method: 'post',
            data: fd,
            callback: res => {
                setProfileClient(res.data);
                setErrorsReturned({});
                setFileType('');
                setFileName('');
                setDocument('');
                setEditingFile('');
                setFileMenuOpen('');
                setDocumentLink('');
                setUploadFilePopup(false);
                setFileComment('');
            },
            catch: err => {
                if (err) {
                    setErrorsReturned(err);
                }
            }
        })
    };

    //get all file types
    const allFileTypes = () => {
        const FileTypes = generalData?.files_type?.map(
            singleFile => ({ value: singleFile.id, label: singleFile.title }))
        return FileTypes;
    }

    //close file popup and reset states
    const closeFilePopup = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setUploadFilePopup(false);
        setFileComment('');
        setFileName('');
        setFileType('');
        setErrorsReturned({});
        setFileMenuOpen(false);
    }

    //handle access to tabs by client type
    useEffect(() => {
        if (authUser?.id && profileClient?.id) {
            if (profileClient?.client_type_id === 2) {
                if (slug !== 'general-info' && slug !== 'documents' && slug !== 'relations'
                    && slug !== 'reminder' && slug !== 'costs') {
                    history('/not-found');
                }
            }
            if (profileClient?.client_type_id === 3) {
                if (slug === 'shareholders' || slug === 'board-members') {
                    history('/not-found');
                }
            }
            if (profileClient?.client_type_id === 1) {
                if (slug === 'administrative-body') {
                    history('/not-found');
                }
            }
            if (authUser?.user_role_id !== 1) {
                if (authUser?.id !== profileClient?.id) {
                    let acc = 0;
                    if (authUser?.user_role?.role_permissions?.length > 0) {
                        authUser?.user_role?.role_permissions.map(element => {
                            if (element?.user_pages['slug'] === slug && element?.['browse_others'] === 1) {
                                acc = 1;
                            }
                            return null;
                        });
                    }
                    if (acc === 0) {
                        history('/not-found');
                    }
                }
            }
        }
        setSecurityCheck(1);
    }, [authUser, profileClient]);// eslint-disable-line react-hooks/exhaustive-deps

    // close expenses popup and reset related states
    function closeAddExpense(e) {
        e.preventDefault();
        setAddExpenses(false);
        setCurrenEditExpense('');
        setAddExpensesType('');
        setAddExpensesAmount('');
        setAddExpensesCurrency('');
        setAddExpensesDate(new Date());
        setAddExpensesNote('');
        setAddExpensesBillable('');
        setDocument();
        setDocumentLink('');
        setErrorsReturned({});
    }

    //get all expenses types
    const allExpensesTypes = () => {
        const expensesTypes = generalData?.expense_types?.map(
            singleOption => ({ value: singleOption.id, label: singleOption.title }))
        return expensesTypes;
    }

    //submit expenses
    const submitExpenses = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let fd = new FormData();
        if (currenEditExpense?.id) {
            fd.append('expense_id', currenEditExpense?.id);
        }

        fd.append('expense_type_id', addExpensesType ? addExpensesType?.value : '');
        fd.append('currency_id', addExpensesCurrency ? addExpensesCurrency?.value : '');
        fd.append('currency', 'usd');
        fd.append('user_id', user_id);
        fd.append('client_id', user_id);
        fd.append('amount', addExpensesAmount ? addExpensesAmount : '');
        fd.append('date', addExpensesDate ? formatDate(addExpensesDate) : '');
        fd.append('note', addExpensesNote ? addExpensesNote : '');
        fd.append('billable', addExpensesBillable ? addExpensesBillable : 0);

        if (document) {
            fd.append('file', document[0]);
        }

        setGeneralDataApiOptions({
            url: 'add-client-expense',
            method: 'post',
            data: fd,
            callback: res => {
                setErrorsReturned({});
                closeAddExpense(e);
            },
            catch: err => {
                if (err) {
                    setErrorsReturned(err);
                }
            }
        })
    };

    //handle swiper menu by slug selected
    useEffect(() => {
        if (slug && swiper && profileClient?.client_type_id === 2) {
            if (slug === 'general-info') {
                setTimeout(() => {
                    swiper?.slideTo(0, 400, true);
                }, 600)
            }
            if (slug === 'documents') {
                setTimeout(() => {
                    swiper?.slideTo(1, 400, true);
                }, 600)
            }
            if (slug === 'relations') {
                setTimeout(() => {
                    swiper?.slideTo(2, 400, true);
                }, 600)
            }
            if (slug === 'reminder') {
                setTimeout(() => {
                    swiper?.slideTo(3, 400, true);
                }, 600)
            }
            if (slug === 'costs') {
                setTimeout(() => {
                    swiper?.slideTo(4, 400, true);
                }, 600)
            }
        }
        if (slug && swiper && profileClient?.client_type_id === 1) {
            if (slug === 'general-info') {
                setTimeout(() => {
                    swiper?.slideTo(0, 400, true);
                }, 600)
            }
            if (slug === 'entity-management') {
                setTimeout(() => {
                    swiper?.slideTo(1, 400, true);
                }, 600)
            }
            if (slug === 'shareholders') {
                setTimeout(() => {
                    swiper?.slideTo(2, 400, true);
                }, 600)
            }
            if (slug === 'board-members') {
                setTimeout(() => {
                    swiper?.slideTo(3, 400, true);
                }, 600)
            }
            if (slug === 'documents') {
                setTimeout(() => {
                    swiper?.slideTo(4, 400, true);
                }, 600)
            }
            if (slug === 'bank-account') {
                setTimeout(() => {
                    swiper?.slideTo(5, 400, true);
                }, 600)
            }
            if (slug === 'relations') {
                setTimeout(() => {
                    swiper?.slideTo(6, 400, true);
                }, 600)
            }
            if (slug === 'signature-authority') {
                setTimeout(() => {
                    swiper?.slideTo(7, 400, true);
                }, 600)
            }
            if (slug === 'reminder') {
                setTimeout(() => {
                    swiper?.slideTo(8, 400, true);
                }, 600)
            }
            if (slug === 'costs') {
                setTimeout(() => {
                    swiper?.slideTo(9, 400, true);
                }, 600)
            }
        }

        // if (slug && swiper && profileClient?.client_type_id === 3) {
        if (slug === 'general-info') {
            setTimeout(() => {
                swiper?.slideTo(0, 400, true);
            }, 600)
        }
        if (slug === 'entity-management') {
            setTimeout(() => {
                swiper?.slideTo(1, 400, true);
            }, 600)
        }
        if (slug === 'administrative-body') {
            setTimeout(() => {
                swiper?.slideTo(2, 400, true);
            }, 600)
        }
        if (slug === 'documents') {
            setTimeout(() => {
                swiper?.slideTo(3, 400, true);
            }, 600)
        }
        if (slug === 'bank-account') {
            setTimeout(() => {
                swiper?.slideTo(4, 400, true);
            }, 600)
        }
        if (slug === 'relations') {
            setTimeout(() => {
                swiper?.slideTo(5, 400, true);
            }, 600)
        }
        if (slug === 'signature-authority') {
            setTimeout(() => {
                swiper?.slideTo(6, 400, true);
            }, 600)
        }
        if (!slug || slug === 'reminder') {
            setTimeout(() => {
                swiper?.slideTo(7, 400, true);
            }, 600)
        }
        if (slug === 'costs') {
            setTimeout(() => {
                swiper?.slideTo(8, 400, true);
            }, 600)
        }
        // }
    }, [slug, swiper]);// eslint-disable-line react-hooks/exhaustive-deps

    //get client data
    useEffect(() => {
        if (authUser) {
            setGeneralDataApiOptions({
                url: 'get-matter-data',
                method: 'post',
                data: {
                    id: Number(matter_id),
                    type: type,
                },
                callback: res => {
                    setActiveMatter(res?.data);
                    setAllLitigations(res?.data?.total['litigations']);

                },
                catch: err => {
                    if (err) {
                        history('/not-found');
                    }
                }
            })
        }
    }, [user_id, slug, matter_id]);// eslint-disable-line react-hooks/exhaustive-deps

    
    const submitDelete = (e, submitted_id) => {
        e.preventDefault();
        e.stopPropagation();
        if (submitted_id) {
            let fd = new FormData();
            fd.append('litigation', submitted_id);
            setGeneralDataApiOptions({
                url: 'delete-litigation',
                method: 'post',
                data: fd,
                callback: res => {
                    setDeleteMatter('');
                    setErrorsReturned({});
                    history('/matters');
                },
                catch: err => {
                    if (err) {
                        setErrorsReturned(err);
                    }
                }
            })
        }
    };


    return (
        <>
            <Layout activePage="matters">
                {
                    (authUser?.id && profileClient?.id === Number(user_id)) || securityCheck === 1 ?
                        <>
                            <div className="row">
                                <div className="col-12 col-sm-auto">
                                    <h1 style={{ textTransform: "capitalize" }} className="page-titles color-dark-blue pb-3">{activeMatter?.title}</h1>
                                </div>
                                {
                                    authUser?.id && authUser?.user_role?.slug === 'admin' ?
                                        <div className="col">
                                            <div className="row">
                                                <div className="col-12 d-flex justify-content-end pb-3">
                                                    <button onClick={() => setDeleteMatter(activeMatter?.id)} className="popup-button my-auto mx-2 w-auto px-3">{generalData?.website_titles['delete']}</button>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            {
                                <Swiper
                                    onSwiper={setSwiper}
                                    className="big-swiper w-100 titles-swiper new-titles-styling-syling"
                                    // spaceBetween={30}
                                    slidesPerView={"auto"}
                                    centeredSlides={false}
                                    resistanceRatio={0}
                                >
                                    <div className="row padding-top-table-settings"  >
                                        <SwiperSlide className={(slug === 'general-info' ? " active-custom-slide" : "")} key={1}>
                                            <h2 onClick={() => history(`/matters/${type}/${activeMatter?.id}/general-info`)} className={`settings-titles color-dark-blue cursor-pointer ${(!slug || slug === 'general-info') ? " active" : ""}`}>{generalData?.website_titles['general-info']}</h2>
                                        </SwiperSlide>
                                        <SwiperSlide className={(slug === 'stages-activities' ? " active-custom-slide" : "")} key={2}>
                                            <h2 onClick={() => history(`/matters/${type}/${activeMatter?.id}/stages-activities`)} className={`settings-titles color-dark-blue cursor-pointer ${slug === 'stages-activities' ? " active" : ""}`}>{generalData?.website_titles['stages-activities']}</h2>
                                        </SwiperSlide>

                                        <SwiperSlide className={(slug === 'documents' ? " active-custom-slide" : "")} key={4}>
                                            <h2 onClick={() => history(`/matters/${type}/${activeMatter?.id}/documents`)} className={`settings-titles color-dark-blue cursor-pointer ${slug === 'documents' ? " active" : ""}`}>{generalData?.website_titles['documents-individual']}</h2>
                                        </SwiperSlide>

                                        <SwiperSlide className={(slug === 'relations' ? " active-custom-slide" : "")} key={6}>
                                            <h2 onClick={() => history(`/matters/${type}/${activeMatter?.id}/relations`)} className={`settings-titles color-dark-blue cursor-pointer ${slug === 'relations' ? " active" : ""}`}>{generalData?.website_titles['relations']}</h2>
                                        </SwiperSlide>

                                        <SwiperSlide className={(slug === 'reminder' ? " active-custom-slide" : "")} key={8}>
                                            <h2 onClick={() => history(`/matters/${type}/${activeMatter?.id}/reminder`)} className={`settings-titles color-dark-blue cursor-pointer ${slug === 'reminder' ? " active" : ""}`}>{generalData?.website_titles['reminder']}</h2>
                                        </SwiperSlide>
                                        <SwiperSlide className={(slug === 'costs' ? " active-custom-slide" : "")} key={9}>
                                            <h2 onClick={() => history(`/matters/${type}/${activeMatter?.id}/costs`)} className={`settings-titles color-dark-blue cursor-pointer ${slug === 'costs' ? " active" : ""}`}>{generalData?.website_titles['costs']}</h2>
                                        </SwiperSlide>
                                    </div>
                                </Swiper>
                            }

                            <div className="management-table pt-0" >
                                {
                                    (!slug || slug === 'general-info') && (activeMatter?.id === Number(matter_id)) && type === 'litigations' &&
                                    <>
                                        <LitigationGeneralInfo />
                                    </>
                                }
                                {
                                    ((slug === 'stages-activities') && (activeMatter?.id === Number(matter_id))) && (type === 'litigations') ?
                                        <LitigationStageActivitiesComponent />
                                        :
                                        null
                                }
                                {
                                    slug === 'documents' ?
                                        <div className="col-12 pt-4">
                                            <Documents
                                                currentFolder={folder_id}
                                                currentUser={matter_id}
                                                mainFolder={3}
                                                mainRoute={'matters/litigations'}
                                                activePage="matters"
                                                subRoute={'documents'}
                                                user_id={activeMatter?.id}
                                            />
                                        </div>
                                        :
                                        null
                                }
                                {
                                    (slug === 'relations') ?
                                        <>
                                            <LitigationRelations
                                                data={activeMatter}
                                                setData={setActiveMatter}
                                                litigationId={matter_id}
                                            />
                                        </>
                                        :
                                        null
                                }

                                {
                                    slug === 'reminder' ?
                                        <LitigationsReminder
                                            marks={activeMatter?.marks}
                                            litigationId={matter_id}
                                        />
                                        :
                                        null
                                }
                                {
                                    slug === 'costs' ?
                                        <>
                                            <LitigationCosts />
                                        </>
                                        :
                                        null
                                }
                            </div>
                        </>
                        :
                        null
                }

                {
                    //reminder popup
                    openAddReminder ?
                        <ReminderPopup selectedDate={new Date()} clientId={Number(user_id)} />
                        :
                        null
                }
                {
                    // upload files popup
                    uploadFilePopup ?
                        <div id="errors-popup" className=" error-popup-api d-flex align-items-center justify-content-center px-3 fade-in">
                            <div className="pop-up-api-box">
                                <CloseIcon className="cursor-pointer" onClick={(e) => closeFilePopup(e)} />
                                <div className="text-center ">
                                    <div className="containter-fluid">
                                        <div className="row">
                                            <div className="col-12">
                                                <h1 className="pop-up-title m-0 py-2 color-dark-blue">{editingFile?.id ? generalData?.documentsSectionSettings['edit-file-title'] : generalData?.documentsSectionSettings['upload-file-title']}</h1>
                                            </div>
                                            <form onSubmit={submitFiles}>
                                                <div className="col-12 pt-2 pb-4">
                                                    <div className="row justify-content-start">
                                                        <div className="col-12 col-md-6 pt-2 pe-md-0">
                                                            <div className="postion-relative d-flex justify-content-start w-100">
                                                                <Select
                                                                    classNamePrefix="popup-select"
                                                                    className="popup-select w-100"
                                                                    styles={customStylesFiles}
                                                                    options={allFileTypes()}
                                                                    components={{
                                                                        IndicatorSeparator: () => null
                                                                    }}
                                                                    placeholder={generalData?.documentsSectionSettings['type-placeholder']}
                                                                    isSearchable={false}
                                                                    value={fileType ? fileType : null}
                                                                    onChange={setFileType} />
                                                            </div>
                                                            {
                                                                errorsReturned?.files_type_id ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text text-start">{errorsReturned?.files_type_id}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 col-md-6 pt-2">
                                                            <input name="file_name" className="add-user-inputs" placeholder={generalData?.documentsSectionSettings['file-name-placeholder']} value={fileName} onChange={(e) => setFileName(e.target.value)} />
                                                            {
                                                                errorsReturned?.file_name ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text text-start">{errorsReturned?.file_name}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 col-md-6 pt-2 pe-md-0 position-relative">
                                                            <input hidden id='upload-document-file' type="file" onChange={(e) => { documentHandlerFiles(e.target.files) }} />
                                                            <label className="pop-upload-file position-relative" htmlFor="upload-document-file">{documentLink ? generalData?.documentsSectionSettings['change-file-placeholder'] : generalData?.documentsSectionSettings['upload-file-placeholder']}</label>

                                                            <AttachIconInput className="download-icon" />
                                                            {
                                                                errorsReturned?.file ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text text-start">{errorsReturned?.file}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 pt-2">
                                                            <textarea type="text-area" name="file_comment" className="add-user-inputs" placeholder={generalData?.documentsSectionSettings['comment-placeholder']} value={fileComment} onChange={(e) => setFileComment(e.target.value)} />
                                                            {
                                                                errorsReturned?.file_comment ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text text-start">{errorsReturned?.file_comment}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 d-flex justify-content-center">
                                                    <button type="submit" className="popup-button my-auto">{editingFile?.id ? generalData?.documentsSectionSettings['change-file-button'] : generalData?.documentsSectionSettings['add-file-button']}</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        null
                }

                {
                    //expenses popup
                    addExpenses ?
                        <div id="errors-popup" className=" error-popup-api d-flex align-items-center justify-content-center px-3 fade-in">
                            <div className="pop-up-api-box">
                                <CloseIcon className="cursor-pointer" onClick={(e) => closeAddExpense(e)} />
                                <div className="text-center ">
                                    <div className="containter-fluid">
                                        <div className="row">
                                            <div className="col-12">
                                                <h1 className="pop-up-title m-0 py-2 color-dark-blue">{currenEditExpense ? generalData?.users_cost_settings['edit-expenses-title'] : generalData?.users_cost_settings['add-expenses-title']}</h1>
                                            </div>
                                            <form onSubmit={submitExpenses}>
                                                <div className="col-12 pt-2 pb-4">
                                                    <div className="row">
                                                        <div className="col-12 col-md-6 pt-2">
                                                            <div className="postion-relative text-start justify-content-start w-100">
                                                                <Select
                                                                    classNamePrefix="popup-select"
                                                                    className="popup-select w-100"
                                                                    styles={customStylesPopup}
                                                                    options={allExpensesTypes()}
                                                                    components={{
                                                                        IndicatorSeparator: () => null
                                                                    }}
                                                                    placeholder={generalData?.users_cost_settings['expenses-type']}
                                                                    isSearchable={false}
                                                                    value={addExpensesType ? addExpensesType : null}
                                                                    onChange={setAddExpensesType} />
                                                            </div>
                                                            {
                                                                errorsReturned?.expense_type_id ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start text-start pop-errors-text">{errorsReturned?.expense_type_id}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 col-md-6 pt-2">
                                                            <div className="postion-relative text-start justify-content-start w-100">
                                                                <Select
                                                                    classNamePrefix="popup-select"
                                                                    className="popup-select w-100"
                                                                    styles={customStylesPopup}
                                                                    options={allCurrencies()}
                                                                    components={{
                                                                        IndicatorSeparator: () => null
                                                                    }}
                                                                    placeholder={generalData?.users_cost_settings['currency']}
                                                                    isSearchable={false}
                                                                    value={addExpensesCurrency ? addExpensesCurrency : null}
                                                                    onChange={setAddExpensesCurrency} />
                                                            </div>
                                                            {
                                                                errorsReturned?.currency_id ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text">{errorsReturned?.currency_id}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 col-md-6 pt-2">
                                                            <input name="amount" value={addExpensesAmount} onChange={(e) => setAddExpensesAmount(e.target.value)} className="add-user-inputs" placeholder={generalData?.users_cost_settings['amount']} />
                                                            {
                                                                errorsReturned?.amount ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text">{errorsReturned?.amount}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 col-md-6 pt-2">
                                                            <div className="postion-relative text-start justify-content-start w-100">
                                                                <DatePicker
                                                                    className="popup-date add-user-inputs"
                                                                    placeholderText={'Date'}
                                                                    value={addExpensesDate ? addExpensesDate : ''}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={addExpensesDate}
                                                                    dateFormat="d MMMM yyyy"
                                                                    onChange={(date) => setAddExpensesDate(date)}
                                                                    minDate={addYears(new Date(), -21)}
                                                                    maxDate={new Date()}
                                                                    locale={localStorage.getItem("BlpLanguage")}
                                                                />
                                                            </div>
                                                            {
                                                                errorsReturned?.date ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text">{errorsReturned?.date}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 col-md-6 pt-2 position-relative">
                                                            <input hidden id='upload-document-file' type="file" onChange={(e) => { documentHandler(e.target.files) }} />
                                                            <label className="pop-upload-file position-relative" htmlFor="upload-document-file">{documentLink ? generalData?.documentsSectionSettings['change-file-placeholder'] : generalData?.documentsSectionSettings['upload-file-placeholder']}</label>

                                                            <AttachIconInput className="download-icon download-svg-popup" />
                                                            {
                                                                errorsReturned?.file ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text text-start">{errorsReturned?.file}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 pt-2">
                                                            <textarea type="text-area" name="note" className="add-user-inputs" placeholder={generalData?.users_cost_settings['note']} value={addExpensesNote} onChange={(e) => setAddExpensesNote(e.target.value)}></textarea>
                                                        </div>
                                                        <div className="col-12 pt-2 d-flex my-auto">
                                                            <div onClick={() => addExpensesBillable === 0 ? setAddExpensesBillable(1) : setAddExpensesBillable(0)} className={'my-auto billable-div ' + (addExpensesBillable ? 'active' : '')}>
                                                            </div>
                                                            <div onClick={() => addExpensesBillable === 0 ? setAddExpensesBillable(1) : setAddExpensesBillable(0)} className="ms-2 billable-popup">{generalData?.users_cost_settings['billable']}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 d-flex justify-content-center">
                                                    <button type="submit" className="popup-button my-auto">{currenEditExpense ? generalData?.users_cost_settings['edit-expenses-button'] : generalData?.users_cost_settings['add-expenses-button']}</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        null
                }

                {
                    //transactions popup
                    addTransaction ?
                        <div id="errors-popup" className=" error-popup-api d-flex align-items-center justify-content-center px-3 fade-in">
                            <div className="pop-up-api-box">
                                <CloseIcon className="cursor-pointer" onClick={(e) => closeAddTransaction(e)} />
                                <div className="text-center ">
                                    <div className="containter-fluid">
                                        <div className="row">
                                            <div className="col-12">
                                                <h1 className="pop-up-title m-0 py-2 color-dark-blue">{currenEditTransaction ? generalData?.users_cost_settings['edit-transaction-title'] : generalData?.users_cost_settings['add-transaction-title']}</h1>
                                            </div>
                                            <form onSubmit={submitTransactions}>
                                                <div className="col-12 pt-2 pb-4">
                                                    <div className="row">
                                                        <div className="col-12 col-md-6 pt-2">
                                                            <div className="postion-relative text-start justify-content-start w-100">
                                                                <Select
                                                                    classNamePrefix="popup-select"
                                                                    className="popup-select w-100"
                                                                    styles={customStylesPopup}
                                                                    options={allTransactionTypes()}
                                                                    components={{
                                                                        IndicatorSeparator: () => null
                                                                    }}
                                                                    placeholder={generalData?.users_cost_settings['transaction-type']}
                                                                    isSearchable={false}
                                                                    isDisabled={true}
                                                                    value={transactionType}
                                                                    onChange={setTransactionType} />
                                                            </div>
                                                            {
                                                                errorsReturned?.transaction_type_id ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text">{errorsReturned?.transaction_type_id}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 col-md-6 pt-2">
                                                            <div className="position-relative text-start justify-content-start w-100">
                                                                <input name="amount" value={transactionAmount} onChange={(e) => setTransactionAmount(e.target.value)} className="add-user-inputs" placeholder={generalData?.users_cost_settings['amount']} />
                                                                <Select
                                                                    classNamePrefix="curr-select"
                                                                    className="curr-select w-100"
                                                                    styles={customStylesPopupCurr}
                                                                    options={allCurrencies()}
                                                                    components={{
                                                                        IndicatorSeparator: () => null
                                                                    }}
                                                                    placeholder={generalData?.users_cost_settings['curr-transaction']}
                                                                    isSearchable={false}
                                                                    value={transactionCurrency ? transactionCurrency : null}
                                                                    onChange={setTransactionCurrency} />
                                                            </div>
                                                            {
                                                                errorsReturned?.currency_id ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text">{errorsReturned?.currency_id}</h5>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                errorsReturned?.amount ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text">{errorsReturned?.amount}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 col-md-6 pt-2">
                                                            <div className="postion-relative text-start justify-content-start w-100">
                                                                <DatePicker
                                                                    className="popup-date add-user-inputs"
                                                                    placeholderText={generalData?.users_cost_settings['date']}
                                                                    value={addTransactionDate ? addTransactionDate : ''}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={addTransactionDate}
                                                                    dateFormat="d MMMM yyyy"
                                                                    onChange={(date) => setAddTransactionDate(date)}
                                                                    minDate={addYears(new Date(), -21)}
                                                                    maxDate={new Date()}
                                                                    locale={localStorage.getItem("BlpLanguage")}
                                                                />
                                                            </div>
                                                            {
                                                                errorsReturned?.date ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text">{errorsReturned?.date}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 col-md-6 pt-2">
                                                            <div className="postion-relative text-start justify-content-start w-100">
                                                                <Select
                                                                    classNamePrefix="popup-select"
                                                                    className="popup-select w-100"
                                                                    styles={customStylesUsersPopup}
                                                                    options={allUsers()}
                                                                    components={{
                                                                        IndicatorSeparator: () => null
                                                                    }}
                                                                    placeholder={generalData?.users_cost_settings['transaction-to']}
                                                                    isSearchable={false}
                                                                    isDisabled={true}
                                                                    value={transactionTo ? transactionTo : null}
                                                                    onChange={setTransactionTo} />
                                                            </div>
                                                            {
                                                                errorsReturned?.receiver_id ?
                                                                    <h5 className="pt-2 m-0 d-flex flex-start pop-errors-text">{errorsReturned?.receiver_id}</h5>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-12 pt-2">
                                                            <textarea type="text-area" name="note" className="add-user-inputs" placeholder={generalData?.users_cost_settings['note']} value={addTransactionNote} onChange={(e) => setAddTransactionNote(e.target.value)}></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 d-flex justify-content-center">
                                                    <button type="submit" className="popup-button my-auto">{currenEditTransaction ? generalData?.users_cost_settings['edit-transaction-button'] : generalData?.users_cost_settings['add-transaction-button']}</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        null
                }
                {
                    // once delete is pressed we show the popup
                    deleteMatter ?
                        <div id="errors-popup" className=" error-popup-api d-flex align-items-center justify-content-center px-3 fade-in">
                            <div className="pop-up-api-box">
                                <CloseIcon className="cursor-pointer" onClick={(e) => setDeleteMatter('')} />
                                <div className="text-center ">
                                    <div className="containter-fluid">
                                        <div className="row d-flex justify-content-center align-items-center">
                                            <div className="col-9 col-sm-12 d-flex justify-content-center">
                                                <h1 className="pop-up-title m-0 pt-3 color-dark-blue">{generalData?.settings_section_settings['delete-popup-title']}</h1>
                                            </div>
                                            <div className="col-12 d-flex justify-content-center pt-4 pb-2">
                                                <button onClick={(e) => submitDelete(e, deleteMatter)} type="button" className="popup-button my-auto mx-2 w-auto px-3">{generalData?.settings_section_settings['delete-popup-first-button']}</button>
                                                <button onClick={(e) => setDeleteMatter('')} type="button" className="auth-button border-dark-blue my-auto mx-2 background-transparent w-auto px-3">{generalData?.settings_section_settings['delete-popup-second-button']}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        null
                }
                <Api options={usersApiOptions} />
                <Api options={generalDataApiOptions} />
            </Layout >
        </>
    )
}